import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Dashboard from './dashboard';
import MyProfile from '../myProfile/myProfile';
import HelpResourceDoc from './pages/HelpResourceDoc';
import ViewAllMessages from './pages/ViewAllMessages/main';
import { DashboardProvider, useDashboardContext } from './context';
import UpdateEmail from './components/Modals/UpdateEmail';
import SendMessage from './components/Modals/SendMessage';
import SelectRecipientModal from './components/Modals/SelectRecipientModal';
import CreateDistributionList from './components/Modals/CreateDistributionList';
import ManageDistList from './components/Modals/ManageDistList';
import GroupDetailsUpdations from './components/Modals/GroupDetailsUpations';

const Main = () => {
  const { allStudents } = useDashboardContext();
  return (
    <>
      <UpdateEmail />
      <SendMessage />
      <SelectRecipientModal
        title={'Select recipients'}
        saveButton={'Save'}
        addRemoveListHeader={'Send Message To'}
        addByLabel={'Add by Distribution Lists'}
        manageButton={'Select/Manage Distribution Lists'}
        dataArray={allStudents}
      />
      <CreateDistributionList />
      <GroupDetailsUpdations />
      <ManageDistList
        title={'Manage Distribution List'}
        label={'Enter the name for the distribution list'}
        createButton={'Create List'}
        firstColumnTitle={'List Name'}
      />
      <Routes>
        <Route element={<Dashboard />} path="/" />
        <Route element={<MyProfile />} path="Profile" />
        <Route element={<HelpResourceDoc />} path="help_resource_doc" />
        <Route element={<ViewAllMessages />} path="view_all_messages/*" />
      </Routes>
    </>
  );
};

const Layout = () => {
  return (
    <DashboardProvider>
      <Main />
    </DashboardProvider>
  );
};

export default Layout;
